import React from 'react';
import './IconBox.css';

const IconBox = ({ website, className = '' }) => {
  const domain = new URL(`http://${website}`).hostname;
  const src = `${process.env.REACT_APP_SERVER_URL}/api/favicon/${encodeURIComponent(domain)}`;

  return (
    <img
      src={src}
      className={`favicon-icon ${className}`.trim()}
      alt=""
    />
  );
};

export default IconBox;
